import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import CoursesPic from "../../../images/CoursesQM.png";

const CoursesPicCont = () => {
  return (
    <div className="QL__PG__PGAboutUsSec">
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <div className="QL__Sec__PGAboutUsmsg">
              <h1 className="HeadingAll">Qur'an Memorization</h1>
              <p className="pt-3">
                Quran memorization (or hafiza) is a skill that can be made
                better by using different techniques and methods. Our
                haafiz-e-Quran tutors are one click away to acquaint you with
                their methods to help you hone your memorization better!
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={CoursesPic} alt="image" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default CoursesPicCont;
